import moment from "moment";
import "moment/locale/pt";

import { Calendar, momentLocalizer } from "react-big-calendar";

import "react-big-calendar/lib/css/react-big-calendar.css";
type SchoolScheduleProps ={
    events:any
}
moment.locale("pt");
const localizer = momentLocalizer(moment);
export const  SchoolSchedule = ({ events }:SchoolScheduleProps)=> {
  const messages = {
    allDay: "Dia inteiro",
    previous: "Anterior",
    next: "Próximo",
    today: "Hoje",
    month: "Mês",
    week: "Semana",
    day: "Dia",
    agenda: "Agenda",
    date: "Data",
    time: "Hora",
    event: "Evento",
    noEventsInRange: "Não há eventos neste período.",
    showMore: (total: any) => `+ Ver mais (${total})`,
  };
  return (
    <>
    <Calendar
      localizer={localizer}
      defaultView="week"
      events={events}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 500 }}
      min={moment().hours(7).minutes(0).toDate()}
      max={moment().hours(23).minutes(0).toDate()}
      views={['week']}
      step={30}
      timeslots={2}
      messages={messages} 

    />
  </>
  )
}


